import React, { createContext, useContext } from 'react';
import type { MyIpCreationOrigin } from '$/domains/myIp/creationHandoff';

const MyIpCreationOriginContext = createContext<MyIpCreationOrigin | null | undefined>(undefined);

/** 画布宿主提供真实来源；null 表示画布尚未就绪，不能降级为新建项目。 */
export function MyIpCreationOriginProvider({ origin, children }: {
  origin: MyIpCreationOrigin | null;
  children: React.ReactNode;
}) {
  return <MyIpCreationOriginContext.Provider value={origin}>{children}</MyIpCreationOriginContext.Provider>;
}

/** 没有画布宿主的首页和列表保持新建项目语义。 */
export function useMyIpCreationOrigin() {
  return useContext(MyIpCreationOriginContext);
}
